import React from 'react'
import { Helmet } from 'react-helmet'

import '../css/Sponsor.css'

export default function Sponsor() {
  return (
    <div id="sponsor">
      <Helmet>
        <title>Sponsor a child - Enoho Fikir</title>
      </Helmet>

      <h1>Sponsor a child</h1>
    </div>
  )
}